  import img1 from "../assets/Yangiliklar/bcard1.png"
  import img2 from "../assets/Yangiliklar/bcard2.png"
  import img3 from "../assets/Yangiliklar/card1.png"
  import img4 from "../assets/Yangiliklar/card2.png"
  import img5 from "../assets/Yangiliklar/top1.png"
  import  img6 from "../assets/Fakultet/Unvrimg.png"
  import img7 from  "../assets/Yangiliklar/Jpg/innovationbox.jpg"
  import img8 from "../assets/Yangiliklar/Jpg/magstr.jpg"
   const photoss= [
    {
  imgurl:img1
    },
    {
        imgurl:img2    }
       ,
       {
        imgurl:img3    }
       ,
       {
        imgurl:img4   },
       {
        imgurl:img5    }
       ,
       {
        imgurl:img6    },
       {
        imgurl:img7    },
       {
        imgurl:img8   },
        {
            imgurl:img3   }
]
export default photoss
